import { Pipe, PipeTransform } from '@angular/core';
import { ContextMenuItem, DisplayColour } from '@shared/components/menu/context-menu-item';
import { AggregatorFeatureFlagService } from '@core/services/aggregator-feature-flag.service';
import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';

export interface DiaryNoteContextMenuComponent {
  editNote(noteId: string): void;
  deleteNote(noteId: string): void;
}

@Pipe({
  name: 'diaryNoteContextMenu'
})
export class DiaryNoteContextMenuPipe implements PipeTransform {

  constructor(private aggregatorFeatureFlagService: AggregatorFeatureFlagService) {}

  transform(noteId: string, component: DiaryNoteContextMenuComponent): ContextMenuItem[] {
    const contextMenus = [
      new ContextMenuItem('Edit', () => {
        component.editNote(noteId);
      })
    ];
    
    if (this.aggregatorFeatureFlagService.isEnabled(AggregatorFeatureFlag.DeleteDiaryNote)) {
      return [
        ...contextMenus,
        new ContextMenuItem(
          'Delete',
          () => {
            component.deleteNote(noteId);
          },
          DisplayColour.Warning
        )
      ];
    }

    return contextMenus;
  }
}
